import React, { useRef } from "react";
import "../Job.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import ArrowBlue from "../../../Assets/Svg/Header/ArrowBlue.svg";
import JobsFormAr from "../JobsFormAr";

export default function JobContainerAr({ JobData }) {
  // Changed JobDataAr to JobData
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const jobData = JobData[0];
  const jobsS5Ref = useRef(null);

  const handleScrollToJobsS5 = () => {
    jobsS5Ref.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="JobsContainer">
      <section>
        <JobsS1
          JobName={jobData.JobName}
          JobLocation={jobData.JobLocation}
          JobType={jobData.JobType}
          JobDepartment={jobData.JobDepartment}
          onScrollToForm={handleScrollToJobsS5}
        />
      </section>
      <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="JobsS2">
        <JobsS2 JobH1Data={jobData.JobH1Data} />
      </VisibilitySection>
      <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="JobsS3">
        <JobsS3 JobH2Data={jobData.JobH2Data} />
      </VisibilitySection>
      <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="JobsS4">
        <JobsS4 JobH4Data={jobData.JobH4Data} />
      </VisibilitySection>
      <section ref={jobsS5Ref} className="">
        <JobsS5 />
      </section>
    </div>
  );
}

function JobsS1({ JobName, JobLocation, JobType, JobDepartment, onScrollToForm }) {
  return (
    <div className="JobsS1">
      <div className="JobsS1P1">
        <TC3L Head={"معلومات الوظيفة"} Title={JobName} />
      </div>
      <div className="JobsS1P23">
        <div className="JobsS1P2">
          <JobsS1P2Box Head="الموقع/" Title={JobLocation} />
          <JobsS1P2Box Head="نوع التوظيف/" Title={JobType} />
          <JobsS1P2Box Head="القسم/" Title={JobDepartment} />
        </div>
        <div className="JobsS1P3">
          <button onClick={onScrollToForm}>
            <div className="TFut16PxPCUC ar JobsS1P3T">إملأ النموذج</div>
            <div>
              <img src={ArrowBlue} alt="" className="ArrowBlue" />
            </div>
          </button>
        </div>
      </div>
      <div className="JobsSLine"></div>
    </div>
  );
}

function JobsS1P2Box({ Head, Title }) {
  return (
    <div className="JobsS1P2Box ar">
      <div className="TF20PxSC JobsS1P2BoxHead ar" dir="rtl">
        {Head}
      </div>
      <div className="TFut20PxPC JobsS1P2BoxTitle ar" dir="rtl">
        {Title}
      </div>
    </div>
  );
}

function JobsS2({ JobH1Data }) {
  return (
    <div className="JobsS2">
      <div className="TFut24PxPC ar JobsS2P1" dir="rtl">
        عن الدور
      </div>
      <div className="TF20PxSC ar JobHData" dir="rtl">
        {JobH1Data}
      </div>
    </div>
  );
}

function JobsS3({ JobH2Data }) {
  return (
    <div className="JobsS3">
      <div className="TFut24PxPC ar JobsS2P1" dir="rtl">
        المسؤوليات
      </div>
      <ul className="TF20PxSC ar JobHData">
        {JobH2Data.map((item, index) => (
          <div key={index} dir="rtl">
            {Object.entries(item).map(([key, value]) => (
              <li key={key}>{value}</li>
            ))}
          </div>
        ))}
      </ul>
    </div>
  );
}

function JobsS4({ JobH4Data }) {
  return (
    <>
      <div className="JobsS4">
        <div className="TFut24PxPC ar JobsS2P1" dir="rtl">
          لماذا تنضم إلى مزرعة ميلكي؟
        </div>
        <ul className="TF20PxSC ar JobHData">
          {JobH4Data.map((item, index) => (
            <div key={index} dir="rtl">
              {Object.entries(item).map(([key, value]) => (
                <li key={key}>{value}</li>
              ))}
            </div>
          ))}
        </ul>
      </div>
      <div className="JobsSLine"></div>
    </>
  );
}

function JobsS5() {
  return <JobsFormAr />;
}
